import resume from '../assets/pdf/SwapnaliDukhandeResume.pdf'

export const headerData = {
    name: 'Swapnali Dukhande',
    title: "Front End Developer",
    desciption:"As a frontend developer, I use my knowledge of HTML, CSS, and JavaScript to design and build attractive and user-friendly web pages. I also have experience working with React.js, which allows me to create complex and reusable user interfaces. ",
    image: 'https://i.ibb.co/hmfpc57/Profile-photo.jpg',
    resumePdf: resume
}
